import Globals from "@/components/globals";
import httpService from "@/components/service";
import cacheService from "@/services/cache";

export default {
    save(brand, zoneId = null, accessUserPlugin, noRefresh = false) {
        Globals.flushLocalStorageDatas();
        cacheService.set("currentBrandId", brand.id);

        if (brand.stands && brand.stands.length > 0) {
            cacheService.set("currentStandId", brand.stands[0].id);
        }

        let zone = brand.zones && brand.zones.length > 0 && (brand.zones.find(zone => zone.id === parseInt(zoneId)) || brand.zones[0]);
        if (zone) {
            cacheService.set("currentZoneId", zone.id);
        } else {
            cacheService.set("currentCampaignId", 0);
        }

        accessUserPlugin.reInit();
        Globals.updatePreferences("brand", noRefresh);
    },
    async get() {
        const response = await httpService.get("/brands/" + cacheService.getCurrentBrandId());
        let brand = response.data[0];
        return brand;
    }
};



// WEBPACK FOOTER //
// ./src/services/currentBrand.js